<template>
  <templateAdminComponent v-if="isUserAuthenticated()">
    <div>
      <h2>Bienvenue au panneau d'administration!</h2>
    </div>
  </templateAdminComponent>
</template>

<script>
import auth from '@/auth'

import TemplateAdminComponent from '@/components/TemplateAdmin.vue'
import api from '@/api'
const APIService = new api();
var axios = require('axios')

export default {
  components:
  {
    TemplateAdminComponent
  },

  methods: {
    isUserAuthenticated() {
      return auth.isUserAuthenticated();
    },

    logout() {
      auth.logout()
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/admin/Accueil.vue